import type { FrontendWidget } from '../types';
import { ListOfLocationsInCityComponent } from './ListOfLocationsInCityComponent';
import type {
  ListOfLocationsInCityConfig,
  ListOfLocationsInCityResolved,
} from './types';

export const listOfLocationsInCityWidget: FrontendWidget<
  ListOfLocationsInCityConfig,
  ListOfLocationsInCityResolved
> = {
  componentType: 'widgets.list-of-locations-in-city',
  displayName: 'List Of Locations In City',
  ComponentA: ListOfLocationsInCityComponent,
  // No resolveSync — lookup widget. Resolved data arrives from the backend.
};
